import React, { Component } from 'react';
import { connect } from 'react-redux';
import KyousaiGrid from "./KyousaiGrid";
import * as ContractSearch from '../ContractSearch/Saga/ContractSearch';
import ContractSearchComponent from '../ContractSearch/Index';
import { Modal, ModalHeader, ModalFooter, ModalBody } from 'reactstrap';
import KyousaiSearch from "./Search";
// import { customerList,  customerNewDispSet } from '../../Store/Customers';
import * as Kyousai from './Saga/Kyousai';
import Draggable from 'react-draggable'; // The default
interface Props {
    // customerNewDispSet: any,
    // customerNewDisp:number,
    // customerno:number,
    // customerList:any,
    // toggle:any,
    get_rent_contract_accounting: any,
    get_kyousais: any,
    change_search_modal: any,
    search_modal: boolean,

}



interface State {
    modalcontract: boolean
    // state types
}

class CustomerList extends Component<Props, State> {


    constructor(props: Readonly<Props>) {
        super(props);



        // this.togglecontract = this.togglecontract.bind(this);



        // this.state = {
        //     modalcontract: false,


        // }



    }





    componentWillMount() {
        this.props.get_kyousais()
        // this.props.customerNewDispSet(0)
        this.submit = this.submit.bind(this);
    }
    //     aa(state:any){
    // console.log(state)
    //     }

    submit(state: any) {
        console.log(state)

        this.props.get_kyousais(state)
    }
    // togglecontract(e: any) {

    //     this.setState(prevState => ({
    //         modalcontract: !prevState.modalcontract,

    //     }));

    //     return
    // }
    csv() {

        // this.props.get_rent_contract_accounting(this.props.kyousais);
    }
    render() {

        return (
            <div className="row" >
                <div className="item-outer col-lg-12"
                //  style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="item">
                        <KyousaiSearch />

                    </div>

                </div>

                {/* <div className="item-outer col-lg-12" style={{ display: (this.props.customerNewDisp === 1) ? '' : 'none' }}>
                    <div className="item">
           
                    </div>
                </div> */}


                <div className="item-outer col-lg-12"
                // style={{ display: (this.props.customerNewDisp === 0) ? '' : 'none' }}
                >
                    <div className="item">
                        <KyousaiGrid />

                    </div>
                </div>

                {/* <Draggable enableUserSelectHack={false}> */}
                <Modal isOpen={this.props.search_modal} toggle={() => this.props.change_search_modal(false)} size="lg" fade={false}>

                    <ModalHeader toggle={() => this.props.change_search_modal(false)}>契約検索</ModalHeader>
                    <ModalBody>
                        <ContractSearchComponent />
                    </ModalBody>
                    <ModalFooter>
                        {/* <button className="btn btn btn-danger" style={{margin:"5px"}} onClick={this.delete_introductions}>削除する</button>*/}
                        <button className="btn btn btn-secondary" style={{ margin: "5px" }} onClick={() => this.props.change_search_modal(false)}>キャンセル</button>
                    </ModalFooter>
                </Modal>
                {/* </Draggable> */}

            </div>
        );
    }
};


//export  default CustomerList;
const mapStateToProps = (state: any) => {
    return {
        // customerNewDisp: state.customersReducer.customerNewDisp,
        // rent_contracts_list: state.rentContractsReducer.rent_contracts_list,
        banks: state.rentContractMoniesReducer.banks,
        search_modal: state.kyousaiReducer.search_modal,
    }
}
function mapDispatchToProps(dispatch: any) {
    return {
        // customerList(search:any) {
        //     dispatch(customerList(search))
        // },
        // customerNewDispSet(state:number) {
        //     dispatch(customerNewDispSet(state))
        // },

        get_kyousais(state: any) {
            dispatch(Kyousai.get_kyousais(state))
        },
        change_search_modal(state: any) {
            dispatch(Kyousai.change_search_modal(state))
        },
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerList);




